var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tab-bar"}},[_c('div',{staticClass:"tab-bar-2-wraper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }